import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PartnerFeedbackWrapper from 'components/ReportCard/RolePlay/PartnerFeedbackWrapper';

const PartnerFeedbackRoot = _ => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path={[
            '/lesson/:lessonId/report',
            '/path/:pathId/lesson/:lessonId/report',
            '/library/lesson/:lessonId/report',
            '/library/path/:pathId/lesson/:lessonId/report',
          ]}
          exact
          component={PartnerFeedbackWrapper}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default PartnerFeedbackRoot;
